<template>
  <div class="page-content d-flex align-items-center justify-content-center">
    <div class="row w-100 mx-0 auth-page">
      <div v-loading="loading" class="col-lg-10 mx-auto">
        <div class="card" v-if="isLogin && userProfile.id">
          <div class="row">
            <div class="col-md-12 pl-md-3">
              <div class="auth-form-wrapper px-4 py-5">
                <h4 class="mb-2">Welcome!</h4>
                <h5 class="text-muted font-weight-normal mb-4">Your Wappin account want to access AI Dasboard.</h5>
                <img src="@/assets/images/404.svg" class="img-fluid mb-2" alt="404">
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="row">
            <div class="col-md-12 pl-md-3">
              <div class="auth-form-wrapper px-4 py-5">
                <h4 class="mb-2">Welcome!</h4>
                <h5 class="text-muted font-weight-normal mb-4">Log in to your Wappin account.</h5>
                <form class="forms-sample" @submit.prevent="doLogin">
                  <div class="form-group">
                    <label for="input-email">Email address</label>
                    <el-input type="email" id="input-email" placeholder="Email" v-model="email" name="email" required/>
                  </div>
                  <div class="form-group">
                    <label for="input-password">Password</label>
                    <el-input type="password" placeholder="Password" v-model="password" name="password" required show-password/>
                  </div>
                  <div class="d-flex justify-content-between mt-3">
                    <button type="submit" class="btn btn-primary mr-2 mb-2 mb-md-0 text-white">Login</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import authAPI from '../../../api/auth';

export default {
  name: 'AIDashboard',
  metaInfo: {
    title: 'SSO AI Chat Kit',
  },
  data() {
    return {
      email: '',
      password: '',
      alert_opt: {
        show: false,
        message: '',
      },
      loading: false,
      data: null,
      popup: null,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin'];
    },
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      this.loading = true;
      if (this.isLogin && this.userProfile.id) {
        if (isEmpty(this.$route.query)) {
          const callbackUrl = 'https://dashboard-chatkit.makna.ai/auth/sso';
          authAPI.botBuilder({
            redirect_uri: callbackUrl,
            workspace_id: this.activeWorkspace._id,
          }).then((res) => {
            if (res.data) {
              this.data = res.data;
              // const authUrl = `${res.data.callback_url}?username=${encodeURIComponent(res.data.username)}&signature=${encodeURIComponent(res.data.signature)}&timestamp=${res.data.timestamp}`;
              // console.log(authUrl);
              // window.open(authUrl, '_blank');
              window.location.href = res.data.callback_url;
            } else {
              this.$router.push({ path: '/404' });
            }
          }).catch(async () => {
            this.$router.push({ path: '/404' });
          });
        } else {
          this.$router.push({ path: '/404' });
        }
      } else {
        this.$router.push({ path: '/404' });
      }
    },
    // async doLogin() {
    //   const OIDC_CLIENT_ID = 'wappin_app_id';
    //   const OIDC_REDIRECT_URI = 'http://localhost:7302/auth/callback';
    //   const OIDC_AUTH_URL = 'http://localhost:8805/authorize';
    //   // const OIDC_TOKEN_URL = 'http://localhost:7100/oauth/token';
    //   // const OIDC_CLIENT_SECRET = 'some_secret_for_the_client';
    //   const state = Math.random().toString(36).substring(2, 15);
    //   localStorage.setItem('oidc_state', state);
    //   const authUrl = `${OIDC_AUTH_URL}?response_type=code&client_id=${OIDC_CLIENT_ID}&redirect_uri=${OIDC_REDIRECT_URI}&scope=openid profile&state=${state}`;
    //   // Open a new pop-up window for the authentication flow.
    //   const windowFeatures = 'width=500,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes';
    //   this.popup = window.open(authUrl, 'SSOLoginPopup', windowFeatures);
    //   // Set up a listener for messages from the pop-up window.
    //   window.addEventListener('message', this.handleMessage, false);
    // },
    // handleMessage(event) {
    //   // Make sure the message is from our trusted origin and has the right data.
    //   if (event.origin !== window.location.origin || !event.data || !event.data.type || event.data.type !== 'authResult') {
    //     return;
    //   }
    //   const { code, state } = event.data.payload;
    //   if (code && state) {
    //     this.exchangeCodeForTokens(code, state);
    //   }
    //   // Clean up after receiving the message.
    //   window.removeEventListener('message', this.handleMessage, false);
    //   if (this.popup) {
    //     this.popup.close();
    //   }
    // },
    // async exchangeCodeForTokens(code, state) {
    //   if (state !== localStorage.getItem('oidc_state')) {
    //     throw new Error('State mismatch. Possible CSRF attack.');
    //   }
    //   localStorage.removeItem('oidc_state');

    //   try {
    //     const response = await authAPI.oauth({
    //       grant_type: 'authorization_code',
    //       code: this.$route.query.response_type,
    //       client_id: this.$route.query.client_id,
    //       client_secret: 'wappin_secret',
    //       redirect_uri: this.$route.query.redirect_uri, // Must match the redirect_uri used in the initial authorize request
    //     });
    //     console.log(response);
    //     // .then(async (res) => {
    //     //   if (!res.error) {
    //     //     await this.$store.dispatch('ui/alertSuccess', 'Register success! Please check your email for verification');
    //     //     window.location.href = this.$route.query.redirect_uri;
    //     //   } else {
    //     //     await this.$store.dispatch('ui/alertError', res.error.message);
    //     //     this.showAlert();
    //     //   }
    //     // }).catch(async () => {
    //     //   await this.$store.dispatch('ui/alertError', 'Something went wrong');
    //     //   this.showAlert();
    //     // });
    //     // const response = await fetch(OIDC_TOKEN_URL, {
    //     //   method: 'POST',
    //     //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //     //   body: new URLSearchParams({
    //     //     grant_type: 'authorization_code',
    //     //     code: code,
    //     //     redirect_uri: OIDC_REDIRECT_URI,
    //     //     client_id: OIDC_CLIENT_ID,
    //     //     client_secret: OIDC_CLIENT_SECRET,
    //     //   })
    //     // });

    //     const tokens = await response.json();
    //     if (tokens.error) {
    //       throw new Error(tokens.error_description || 'Token exchange failed.');
    //     }

    //     localStorage.setItem('access_token', tokens.access_token);
    //     localStorage.setItem('id_token', tokens.id_token);
    //     // Force a page reload to update the component state.
    //     // window.location.reload();
    //   } catch (e) {
    //     console.error('Authentication error:', e);
    //   }
    // },
  },
};
</script>
